import firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDP0aLn6ypuCLyRTCACkW6Fx2p1eTFxjhU",
  authDomain: "lcmembers.firebaseapp.com",
  databaseURL: "https://lcmembers.firebaseio.com",
  projectId: "lcmembers",
  storageBucket: "lcmembers.appspot.com",
  messagingSenderId: "58116420393",
  appId: "1:58116420393:web:0e63c72b7ae44f49fa7d38",
  measurementId: "G-BPP81DLNGT"
};



firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

auth.loggedIn = function() {
    //console.log('LOGGED IN method current user',this.currentUser);
    
    return this.currentUser ? true : false;
  }

export default { auth, db, storage };
